import { render, staticRenderFns } from "./hallOfFame.vue?vue&type=template&id=10f03eec&scoped=true"
import script from "./hallOfFame.vue?vue&type=script&lang=js"
export * from "./hallOfFame.vue?vue&type=script&lang=js"
import style0 from "./hallOfFame.vue?vue&type=style&index=0&id=10f03eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f03eec",
  null
  
)

export default component.exports